import { EntityDetail } from '../../entityFramework/entityDetail/EntityDetail';
import { EntityPropForm } from './EntityPropForm';

export const EntityPropDetail = () => {

  // const { entityObj } = useEntityMgr();

  // const deleteData = {
  //   title: 'Delete Entity Property',
  //   entity: 'ENTITY_PROP',
  //   entityId: entityObj.id,
  //   pluginCode: 'DEFAULT_DELETE_ACTION_PLUGIN'
  // }

  // const augButtons = (buttons) => {
  //   buttons.push(<ActionButton data={deleteData} toolTip="Delete" icon={fas.faCircleXmark} />);
  // }

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityPropForm /> },
  ]

  // augButtons={augButtons}

  return (
    <EntityDetail tabSpecs={tabSpecs} />


  )
}